/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Work_0_BadgeInputs */

const en_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversational AI tutor`)
};

const ar_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم ذكاء اصطناعي محادث`)
};

const bn_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কথোপকথনমূলক এআই শিক্ষক`)
};

const de_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächsorientierter KI-Tutor`)
};

const es_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor de IA conversacional`)
};

const fr_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuteur IA conversationnel`)
};

const pt_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor de IA conversacional`)
};

const zh_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话式 AI 家教`)
};

const tr_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konuşkan YZ eğitmen`)
};

const ru_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разговорный ИИ-тьютор`)
};

const pl_svc_ai_voice_agents_work_0_badge = /** @type {(inputs: Svc_Ai_Voice_Agents_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konwersacyjny tutor AI`)
};

/**
* | output |
* | --- |
* | "Conversational AI tutor" |
*
* @param {Svc_Ai_Voice_Agents_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_work_0_badge = /** @type {((inputs?: Svc_Ai_Voice_Agents_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_work_0_badge(inputs)
	return en_svc_ai_voice_agents_work_0_badge(inputs)
});
export { svc_ai_voice_agents_work_0_badge as "svc_ai-voice-agents_work_0_badge" }